import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    brand: {
      50: '#f5f9ff',
      100: '#e6f0ff',
      200: '#bfd4ff',
      300: '#99b9ff',
      400: '#4d83ff',
      500: '#004dff',
      600: '#0045e6',
      700: '#0038bf',
      800: '#002b99',
      900: '#001f73',
    },
  },
  fonts: {
    heading: 'Inter, system-ui, sans-serif',
    body: 'Inter, system-ui, sans-serif',
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'brand',
      },
    },
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
      },
    },
  },
});

export default theme; 